import script from "./Title.vue?vue&type=script&lang=ts&setup=true"
export * from "./Title.vue?vue&type=script&lang=ts&setup=true"

import "./Title.vue?vue&type=style&index=0&id=df17b3c8&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df17b3c8"]])

export default __exports__